<template>
  <div class="select">
    <select :class="{ empty: !ivalue }" v-model="ivalue">
      <option v-if="placeholder" value="" disabled selected>{{ placeholder }}</option>
      <option v-for="(option, index) in options" :key="index" :value="option.value">{{ option.label || option.value }}</option>
    </select>
    <span v-if="hint">{{ hint }}</span>
  </div>
</template>

<script>
  export default {
    name: 'Select',
    components: {},
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      placeholder: {
        type: String,
        default: null,
      },
      hint: {
        type: String,
        default: null,
      },
      validator: {
        type: [RegExp, Function],
        default: null,
      },
      value: {
        type: String,
        default: null,
      },
      noTracking: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        ivalue: this.value || '',
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      value(val) {
        this.ivalue = val;
      },
      ivalue(val) {
        this.validate(val);
        this.$emit('update:value', val);
        this.$emit('input', val);
      },
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      validate(val = null) {
        const value = val || this.ivalue;
        const validator = this.validator;
        const ref = this.$vnode.data.ref;
        const noTracking = this.noTracking;

        if (validator) {
          if (validator.constructor === RegExp && (value === null || !validator.test(value))) {
            this.invalid = true;
            if (!noTracking) {
              this.$b.analytics.trackFormField(ref, !this.invalid, value);
            }
            return false;
          }
          if (validator.constructor === Function && (value === null || !validator(value))) {
            this.invalid = true;
            if (!noTracking) {
              this.$b.analytics.trackFormField(ref, !this.invalid, value);
            }
            return false;
          }
        }
        this.invalid = false;
        if (!noTracking) {
          this.$b.analytics.trackFormField(ref, !this.invalid, value);
        }
        return true;
      },
    },
  };
</script>

<style lang="scss">
  @import '~scss/variables';
  @import '~scss/mixins';

  .select {
    position: relative;
    &:after {
      position: absolute;
      z-index: 10;
      display: block;
      content: '>';
      width: auto;
      height: inherit;
      margin-right: 8px;
      transform-origin: 50% 50%;
      top: 17px;
      color: $color-gray;
      right: 14px;
      transform: translate(0, 0) rotate(90deg) scale(0.9, 1.8);
    }

    & > select {
      display: block;
      appearance: none;
      width: 100%;
      border: 1px solid $color-gray;
      border-radius: 3px;
      background: transparent;
      outline: 0;
      padding: 13px 50px 12px 16px;
      margin: 0;
      height: 52px;
      color: $color-white;
      @include font-daimler-cs(400);
      font-size: 1.9rem;

      &.empty {
        color: $color-gray;
      }

      &::-ms-expand {
        display: none;
      }
      &::-ms-value {
        background: none;
      }
      &:-moz-focusring {
        color: transparent;
        text-shadow:0 0 0 $color-white;
      }
      &:focus {
        border-color: $color-blue;
        outline: 0;
      }

      & > option {
        color: $color-black;
        background: transparent;

        &:disabled {
          color: $color-gray;
        }
      }
    }

    & > span {
      display: block;
      padding: 8px 16px 0 8px;
    }
  }
</style>
